// extracted by mini-css-extract-plugin
export var deleteModal = "_ft-0";